import { render, staticRenderFns } from "./TemplateMessageForm.vue?vue&type=template&id=e1e45344&scoped=true"
import script from "./TemplateMessageForm.vue?vue&type=script&lang=js"
export * from "./TemplateMessageForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageForm.vue?vue&type=style&index=0&id=e1e45344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e45344",
  null
  
)

export default component.exports